// extracted by mini-css-extract-plugin
export var avatar = "_8-b";
export var brand = "_8-1";
export var brandLink = "_8-2";
export var brandLogo = "_8-3";
export var brandSubmark = "_8-4";
export var footer = "_8-a";
export var gear = "_8-f";
export var gearActive = "_8-g";
export var identity = "_8-c";
export var identityEmail = "_8-e";
export var identityName = "_8-d";
export var nav = "_8-5";
export var navIcon = "_8-9";
export var navItem = "_8-7";
export var navItemActive = "_8-8";
export var section = "_8-6";
export var sidebar = "_8-0";